module.exports = __webpack_public_path__ + "img/lady3.c04a7ef3.png";